// Pure: derives the summary strip from tile states.
export const SUMMARY_SEPARATOR = " · ";

export function buildSummary(tiles) {
  const count = (state) => tiles.filter((t) => t.state === state).length;
  const broken = count("broken");
  const alert = count("alert");
  const waiting = count("waiting");
  const healthy = count("healthy");
  const allHealthy = healthy === tiles.length;
  const remaining = tiles.length - broken - alert - waiting;

  const parts = [{ key: "broken", text: `${broken} broken`, tone: broken ? "red" : "neutral" }];
  if (alert) parts.push({ key: "alert", text: `${alert} ${alert === 1 ? "alert" : "alerts"} firing`, tone: "amber" });
  if (waiting) parts.push({ key: "waiting", text: `${waiting} waiting on you`, tone: "amber" });
  if (allHealthy) parts.push({ key: "green", text: "everything green", tone: "green" });
  else if (remaining > 0 && healthy === remaining) parts.push({ key: "green", text: "everything else green", tone: "neutral" });

  const tone = broken ? "red" : alert || waiting ? "amber" : allHealthy ? "quiet" : "neutral";
  return { parts, tone, text: parts.map((p) => p.text).join(SUMMARY_SEPARATOR) };
}
